import {JSONMapped, jsonProperty} from "json-mapper-reflect";

export class GPAircraft extends JSONMapped() {
	@jsonProperty()
	garminPilotID: string;

	@jsonProperty()
	garminPilotDataVersion: number;

	@jsonProperty()
	filingType: string;

	@jsonProperty()
	aircraftColors: Array<string>;

	@jsonProperty()
	homeAirport: string;

	@jsonProperty()
	fuelCapacity: number;

	@jsonProperty()
	fuelType: string;

	@jsonProperty()
	fuelUnit: string;

	@jsonProperty()
	airspeed: number;

	@jsonProperty()
	climbAirspeed: number;

	@jsonProperty()
	descentAirspeed: number;

	@jsonProperty()
	fuelBurnRate: number;

	@jsonProperty()
	climbBurnRate: number;

	@jsonProperty()
	descentBurnRate: number;

	@jsonProperty()
	cruiseAltitude: number;

	@jsonProperty()
	altitudeCeiling: number;

	@jsonProperty()
	climbRate: number;

	@jsonProperty()
	descentRate: number;

	@jsonProperty()
	associatedBinderID: string;


	constructor(data?: Partial<GPAircraft>) {
		super();
		Object.assign(this, data);
	}

	get colorString(): string {
		return this.aircraftColors.join("/");
	}

	set colorString(colorString: string) {
		this.aircraftColors = colorString.split("/");
	}
}
